const routes = [{
  path: '/servicePackage/servicePackageConfig',
  component: () => import('@/views/servicePackage/servicePackageConfig'),
  name: 'servicePackage/servicePackageConfig',
  meta: {
    title: '服务包配置'
  }
}, {
  path: '/servicePackage/equitiesGrantRecord',
  component: () => import('@/views/servicePackage/equitiesGrantRecord'),
  name: 'servicePackage/equitiesGrantRecord',
  meta: {
    title: '权益下发记录'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/servicePackage.js